var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLucideLanguages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 8 6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4 14 6-6 2-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5h12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22 22-5-10-5 10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18h6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideLanguages);
export default __webpack_public_path__ + "static/media/lucide-languages.604ace92fe122850c0c2f50985dc2f4b.svg";
export { ForwardRef as ReactComponent };